import React, { Component } from "react";
import Landing from "./LandingContainer";
import { LANDING_MENU_BAR } from "./../../constants/strings/StringsDashboard";
import { sendService } from '../../Services/service'

import "./../changePasswordContainer.css";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as modalActs from "./../../Actions/Modal";


import IndividualForm from "../components/IndividualComponent";
import AddVictim from "../components/AddVictimComponent";

import { srcCorregimientos } from "../../constants/services/map";

import { Map } from '../../Services/map'

class IndividualLoadContainer extends Component {
  state = {
    mapMarker: false,
    form: {
      refFenomenoId: 1,
      fechaCorte: new Date(),
      cantidad: 1,
      victims: [],
    },
    victim: {},
    addVictim: false
  };

  handlerChange = (variable, value) => {
    this.setState({
      form: {
        ...this.state.form,
        [variable]: value
      }
    })
    if (variable === 'lat' || variable === 'lng') {
      this.setState({ mapMarker: false })
    }
    if (variable === 'refMpioId') {
      let mpio = ''
      switch (parseInt(value)) {
        case 1: mpio = '045'; break
        case 2: mpio = '147'; break
        case 3: mpio = '172'; break
        case 4: mpio = '480'; break
        case 5: mpio = '490'; break
        case 6: mpio = '837'; break
        case 7: mpio = '665'; break
        case 8: mpio = '659'; break
        case 9: mpio = '475'; break
        case 10: mpio = '051'; break
        default: break
      }
      this.map.DeletePolysInMap(this.mpios)
      this.map.SetPolysInMap(this.mpios, mpio)
      this.map.fitAllMap(this.mpios, mpio)
    }
  }

  focusOut = () => {
    if (this.state.form.lat !== undefined && this.state.form.lng !== undefined && !this.state.mapMarker) {
      try { this.map.deleteMarker() } catch (e) { }
      this.map.createMarker({ lat: Number(this.state.form.lat), lng: Number(this.state.form.lng) })
      this.setState({ mapMarker: true })
    }
  }

  handlerSubmit = async () => {
    let dato = {
      ...this.state.form,
      fechaFenomeno:  `${this.state.form.fechaFenomeno}T${this.state.form.horaFenomeno}:${this.state.form.minutoFenomeno}:00.000Z`
    }
    this.props.modalActions.openLoader()
    let resp = await sendService('/api/v1/dashboard/uploadIndividual', 'POST', dato)
    console.log('resp', resp)
    this.props.modalActions.closeLoader()
    if (resp.status !== 200) {
      this.props.modalActions.openModal(<label>Hubo un error</label>)
      return false
    }
    return true
  };

  handlerVictim = (variable, value) => {
    this.props.modalActions.closeModal()
    const victim = {
      ...this.state.victim,
      [variable]: value
    }
    this.setState({ victim })
    this.props.modalActions.openModal(
      <AddVictim
        onChange={this.handlerVictim}
        onSubmit={this.handlerVictimSubmit}
        closeModal={this.closeModal}
        values={victim}
      />
    )
  }

  handlerVictimSubmit = () => {
    console.log('victima:', this.state.victim)
    let victims = this.state.form.victims
    victims.push(this.state.victim)
    this.setState({ form: { ...this.state.form, victims }, victim: {} })
    this.closeModal()
  }

  addMurdered = () => {
    this.setState({ addVictim: true })
    this.props.modalActions.openModal(
      <AddVictim
        onChange={this.handlerVictim}
        onSubmit={this.handlerVictimSubmit}
        closeModal={this.closeModal}
        values={this.state.victim}
      />
    )
  }

  closeModal = () => {
    this.props.modalActions.closeModal();
  };

  startMap = () => {
    setTimeout(async () => {
      this.map = new Map("map-murder")
      this.mpios = await this.map.HttpServiceCroquis(srcCorregimientos)
      this.map.SetPolysInMap(this.mpios)
    }, 300)
  }

  render() {
    return (
      <>
        <Landing history={this.props.history} hasFooter={true}>
          <>
            <div>
              <h1 className="page-title">{LANDING_MENU_BAR.INDIVIDUALE_LOAD}</h1>
            </div>
            <IndividualForm
              onChange={this.handlerChange}
              onSubmit={this.handlerSubmit}
              addMurdered={this.addMurdered}
              startMap={this.startMap}
              focusOut={this.focusOut}
              values={this.state.form}
            />
            <div className='line line-100 text-center'>
              {
                this.state.form.victims.map((vic, i) => <p key={'victim-key-' + i} className='victima-agregada'><i className='fas fa-check primary-color'></i>&nbsp;{vic.victima}</p>)
              }
            </div>
            <div className='line line-100'></div>
          </>
        </Landing>
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    modalActions: bindActionCreators(modalActs, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(IndividualLoadContainer);
// export default IndividualLoadContainer;
